/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Vermoegensleistungenid3Inputs */



/**

* @param {_Field_Vermoegensleistungenid3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_vermoegensleistungenid3 = /** @type {((inputs?: _Field_Vermoegensleistungenid3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Vermoegensleistungenid3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Vermögenswirksame Leistungen")
});
export { _field_vermoegensleistungenid3 as "_field_vermoegensLeistungenID" }